import { render, staticRenderFns } from "./WechatIndex.vue?vue&type=template&id=5e68dde2&scoped=true&"
import script from "./WechatIndex.vue?vue&type=script&lang=js&"
export * from "./WechatIndex.vue?vue&type=script&lang=js&"
import style0 from "./WechatIndex.vue?vue&type=style&index=0&id=5e68dde2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e68dde2",
  null
  
)

export default component.exports